"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flexPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const as = ['div', 'span'];
const displayValues = ['none', 'inline-flex', 'flex'];
const directionValues = ['row', 'column', 'row-reverse', 'column-reverse'];
const alignValues = ['start', 'center', 'end', 'baseline', 'stretch'];
const justifyValues = ['start', 'center', 'end', 'between'];
const wrapValues = ['nowrap', 'wrap', 'wrap-reverse'];
const flexPropDefs = {
    as: { type: 'enum', values: as, default: 'div' },
    asChild: index_js_1.asChildProp,
    display: {
        type: 'enum',
        className: 'rt-r-display',
        values: displayValues,
        default: 'flex',
        responsive: true,
    },
    direction: {
        type: 'enum',
        className: 'rt-r-fd',
        values: directionValues,
        default: undefined,
        responsive: true,
    },
    align: {
        type: 'enum',
        className: 'rt-r-ai',
        values: alignValues,
        default: undefined,
        responsive: true,
    },
    justify: {
        type: 'enum',
        className: 'rt-r-jc',
        values: justifyValues,
        parseValue: parseJustifyValue,
        default: 'start',
        responsive: true,
    },
    wrap: {
        type: 'enum',
        className: 'rt-r-fw',
        values: wrapValues,
        default: undefined,
        responsive: true,
    },
    ...index_js_1.gapProps,
};
exports.flexPropDefs = flexPropDefs;
function parseJustifyValue(value) {
    return value === 'between' ? 'space-between' : value;
}
//# sourceMappingURL=flex.props.js.map